import { render } from "./CategoriesPage.vue?vue&type=template&id=1029f6c7&scoped=true&ts=true"
import script from "./CategoriesPage.vue?vue&type=script&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&lang=ts"

import "./CategoriesPage.vue?vue&type=style&index=0&id=1029f6c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1029f6c7"]])

export default __exports__